<template>
  <div class="cloud-perfume-tooltip">
    <div class="wrapper">
      <div class="content">
        <div v-if="$asyncComputed.data.updating" class="loading">LOADING</div>
        <div v-else class="perfume-info">
          <div
            class="image"
            :style="{ backgroundImage: `url(${data.imageUrl})` }"
          />
          <div class="brand">{{ data.brand.name }}</div>
          <div class="name">{{ data.name }}</div>
          <families-with-icon
            :family="data.family"
            :subfamily="data.secondaryFamily"
          ></families-with-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPerfume } from "@/services/Api";
import FamiliesWithIcon from "../FamiliesWithIcon.vue";
export default {
  components: { FamiliesWithIcon },
  props: ["metaData"],
  asyncComputed: {
    data() {
      return getPerfume(this.metaData.id);
    },
  },
};
</script>

<style lang="stylus" scoped>
.cloud-perfume-tooltip
  position: absolute
  z-index: 1

  .wrapper
    box-shadow: 0 4px 40px rgba(0, 0, 0, 0.2)
    left: 50%
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)

  .content
    background-color: #fff
    border-radius: 8px
    max-width: vw(300px)
    padding: vw(30px) vw(20px)

    .image
      background-position: center
      background-repeat: no-repeat
      background-size: contain
      height: vw(160px)
      margin-bottom: vw(20px)
      margin-left: auto
      margin-right: auto
      width: vw(160px)

    .brand
      m-ellipsis(100%)
      m-font-size(12, 12)
      m-letter-spacing(20)
      margin-bottom: vw(5px)

    .name
      m-ellipsis(100%)
      m-font-size(18, 18)
      m-letter-spacing(20)
      margin-bottom: vw(5px)
</style>